import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import GrainOverlay from "@/components/GrainOverlay";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import OpenClasses from "@/pages/OpenClasses";
import EventDetail from "@/pages/EventDetail";
import PrivateBookings from "@/pages/PrivateBookings";
import GalleryPage from "@/pages/GalleryPage";
import { seed } from "@/lib/api";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // If the URL has a hash (e.g. /private-bookings#contact), scroll to that
    // element instead of resetting to top. Run on a microtask delay to give
    // the destination route's content time to mount.
    const scrollToTarget = () => {
      if (hash) {
        const id = hash.replace(/^#/, "");
        const el = document.getElementById(id);
        if (el) {
          if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
            window.__lenis.scrollTo(el, { immediate: false, force: true, offset: -100 });
          } else {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
          return true;
        }
      }
      return false;
    };

    // Reset scroll first, then attempt to anchor.
    if (typeof window !== "undefined" && window.__lenis && typeof window.__lenis.scrollTo === "function") {
      window.__lenis.scrollTo(0, { immediate: true, force: true });
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    if (typeof document !== "undefined") {
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    if (hash) {
      // Try a few times; the page section may take a tick to render.
      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (scrollToTarget() || tries > 20) clearInterval(t);
      }, 80);
      return () => clearInterval(t);
    }
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    // Idempotent seed of sample events on first load
    seed().catch(() => {});
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <GrainOverlay />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/classes" element={<OpenClasses />} />
              <Route path="/classes/:slug" element={<EventDetail />} />
              <Route path="/private-bookings" element={<PrivateBookings />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/journal" element={<GalleryPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "#1A1715",
                color: "#F9F6F0",
                border: "1px solid rgba(249,246,240,0.15)",
                borderRadius: "2px",
                fontFamily: '"Outfit", system-ui, sans-serif',
                letterSpacing: "0.05em",
              },
            }}
          />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
